// src/services/CardService.js
import { api } from "../api";
import { UserService } from "./UserService";

export const CardService = {
  async list() {
    try {
      const resp = await api.get(`users/payment-methods`);
      return resp.data;
    } catch (e) {
      try {
        const legacy = await UserService.getPaymentMethods();
        return legacy;
      } catch (err) {
        throw e;
      }
    }
  },
  async add(card) {
    console.log('zz:card::', JSON.stringify(card));
    const resp = await api.post(`users/payment-methods`, card);
    return resp.data;
  },
  async remove(cardOrId) {
    const cardId =
      cardOrId && typeof cardOrId === "object"
        ? cardOrId.pm_id || cardOrId.payment_method_id || cardOrId.id
        : cardOrId;
    try {
      const resp = await api.delete(`users/payment-methods/${cardId}`);
      const data = resp?.data;
      if (data && (data.error || data.status === 0 || data.ok === false)) {
        const msg = data.error || data.message || "Falha ao remover cartão";
        throw new Error(msg);
      }
      return data;
    } catch (e) {
      const msgV2 = e?.response?.data?.error || e?.response?.data?.message;
      const finalMsg = msgV2 || e?.message || "Falha ao remover cartão";
      throw new Error(finalMsg);
    }
  },
  async select(cardId) {
    try {
      const resp = await api.post(
        `users/payment-methods/${cardId}/set-default`,
      );
      return resp?.data;
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e?.message ||
        "Falha ao definir cartão padrão";
      throw new Error(msg);
    }
  },
  async update(cardId, data) {
    const resp = await api.put(`users/payment-methods/${cardId}`, data);
    return resp.data;
  },
};
